import React, { useEffect, useState } from 'react';
import Button from './Button';
export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };
  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-navy shadow-lg z-50" data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-109">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-110">
          <div className="flex-1" data-id="element-111">
            <p className="text-dark text-sm" data-id="element-112">
              We use cookies to improve your experience on our site. By
              continuing to use this site, you consent to our use of cookies for
              analytics and performance. You can learn more in our{' '}
              <a href="/privacy" className="text-sky-blue hover:underline font-medium" data-id="element-113">
                Privacy & Cookie Policy
              </a>
              .
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0" data-id="element-114">
            <button onClick={handleDecline} className="px-4 py-2 text-sm font-medium text-dark hover:text-navy transition-colors" aria-label="Decline cookies" data-id="element-115">
              Decline
            </button>
            <Button onClick={handleAccept} size="sm" data-id="element-116">
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>;
}